export default function(router) {
    router.map({
        '/': {
            name: '首页',
            component: require('./wuyan/index.vue'),
            subRoutes: {
                '/': {
                    name: '首页',
                    component: require('./wuyan/pc.vue')
                },
            }
        },
        '/index': {
            name: '首页',
            component: require('./wuyan/index.vue'),
            subRoutes: {
                '/pc': {
                    name: '首页',
                    component: require('./wuyan/pc.vue')
                },

                '/workList': {
                    name: '课件列表',
                    component: require('./wuyan/workList.vue')
                },
                '/workInfo': {
                    name: '课件详情',
                    component: require('./wuyan/workInfo.vue')
                },
                '/norisukeList': {
                    name: '产品列表',
                    component: require('./wuyan/norisukeList.vue')
                },
                   '/shopInfo': {
                    name: '店铺详情',
                    component: require('./wuyan/shopInfo.vue')
                },
                   '/norisukeInfo': {
                    name: '教辅详情',
                    component: require('./wuyan/norisukeInfo.vue')
                },

                //XYL
                '/listendownpc': {
                    name: '单元听力下载列表',
                    component: require('./wuyan/listendownpc.vue')
                },
                '/listenbookpc': {
                    name: '听力下载展示',
                    component: require('./wuyan/listenbookpc.vue')
                },
                '/findinfopc': {
                    name: '公司文化，系统消息',
                    component: require('./wuyan/findinfopc.vue')
                },
                '/tellOur': {
                    name: '联系我们',
                    component: require('./wuyan/tellOur.vue')
                },
            }
        }
    });
}


// WEBPACK FOOTER //
// ./src/route.wuyan.js